import Splide from '@splidejs/splide';

const EL = '.js-about-carousel';

document.querySelectorAll('.js-about-carousel').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: true,
    gap: 60,
    autoWidth: true,
    type: 'loop',
    breakpoints: {
      1024: {
        gap: 30,
      },
      767: {
        gap: 10,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');


  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }
});
